var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonthlyClosings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.315 15.315",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M3.669,3.71h0.696c0.256,0,0.464-0.165,0.464-0.367V0.367C4.829,0.164,4.621,0,4.365,0H3.669 C3.414,0,3.206,0.164,3.206,0.367v2.976C3.205,3.545,3.413,3.71,3.669,3.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M10.95,3.71h0.696c0.256,0,0.464-0.165,0.464-0.367V0.367C12.11,0.164,11.902,0,11.646,0H10.95 c-0.256,0-0.463,0.164-0.463,0.367v2.976C10.487,3.545,10.694,3.71,10.95,3.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M14.512,1.42h-1.846v2.278c0,0.509-0.458,0.923-1.021,0.923h-0.696 c-0.563,0-1.021-0.414-1.021-0.923V1.42H5.384v2.278c0,0.509-0.458,0.923-1.021,0.923H3.669c-0.562,0-1.02-0.414-1.02-0.923V1.42 H0.803c-0.307,0-0.557,0.25-0.557,0.557V14.76c0,0.307,0.25,0.555,0.557,0.555h13.709c0.308,0,0.557-0.248,0.557-0.555V1.977 C15.069,1.67,14.82,1.42,14.512,1.42z M14.316,9.49v4.349c0,0.096-0.078,0.176-0.175,0.176H7.457H1.174 c-0.097,0-0.175-0.08-0.175-0.176V10.31V5.961c0-0.096,0.078-0.176,0.175-0.176h6.683h6.284l0,0c0.097,0,0.175,0.08,0.175,0.176 V9.49z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.327,
    y: 8.93,
    style: {
      fill: "#ffffff"
    },
    width: 1.735,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.28,
    y: 8.93,
    style: {
      fill: "#ffffff"
    },
    width: 1.735,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.204,
    y: 8.93,
    style: {
      fill: "#ffffff"
    },
    width: 1.734,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.156,
    y: 8.93,
    style: {
      fill: "#ffffff"
    },
    width: 1.736,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.363,
    y: 11.432,
    style: {
      fill: "#ffffff"
    },
    width: 1.736,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.317,
    y: 11.432,
    style: {
      fill: "#ffffff"
    },
    width: 1.735,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.241,
    y: 11.432,
    style: {
      fill: "#ffffff"
    },
    width: 1.734,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.194,
    y: 11.432,
    style: {
      fill: "#ffffff"
    },
    width: 1.735,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.215,
    y: 6.47,
    style: {
      fill: "#ffffff"
    },
    width: 1.735,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.17,
    y: 6.47,
    style: {
      fill: "#ffffff"
    },
    width: 1.734,
    height: 1.735
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyClosings);
export default __webpack_public_path__ + "static/media/monthlyClosings.dac05153c774d15dbe6d5c191280e7f6.svg";
export { ForwardRef as ReactComponent };